<template>
  <div class="contents">
    <div class="grid">
      <div class="grid-cell">
        <p>201612127 筑波 太郎</p>
      </div>
      <div class="grid-cell twice">
        <p>1/3</p>
      </div>
      
      <div class="grid-cell">
        <p>取得単位数 130/126 OK</p>
        <p>自由科目 23.5/28.5 NG</p>
        <p>卒業要件 NG</p>
      </div>
      <div class="grid-cell">
        <p>取得単位数 130/126 OK</p>
        <p>自由科目 23.5/28.5 NG</p>
        <p>卒業要件 NG</p>
      </div>
    </div>
    <!-- <div class="grid">
      <div class="grid-cell">
        <p>1/2</p>
      </div>
      <div class="grid-cell">
        <p>1/2</p>
      </div>
    </div>
    <div class="grid">
      <div class="grid-cell">
        <p>1/3</p>
      </div>
      <div class="grid-cell">
        <p>1/3</p>
      </div>
      <div class="grid-cell">
        <p>1/3</p>
      </div>
    </div>
    <div class="grid">
      <div class="grid-cell">
        <p>1/4</p>
      </div>
      <div class="grid-cell twice">
        <p>1/2</p>
      </div>
      <div class="grid-cell">
        <p>1/4</p>
      </div>
    </div> -->
    
    <div class="grid">
      <div class="grid-cell">
        <p>あなたは当時もうその安心通りというものの時になっざるた。</p>
      </div>
      
      <div class="grid-cell">
        <p>けっして絶対を話人はとにかくどんな計画ましでしょくらいをして下さろだからは相当まかり出ないませて、そうには言い直すななりだます。圏外を得でのも何でもかでも途中にはたしてでません。ただいま嘉納さんを病気胃とても学習になっませ日本人その弟誰か相違がという小妨害だなくたたくて、その事実はここか条件衣食が飛びて、嘉納さんのもので場所の私にあたかも実料理と違いばその他書物からご観念を眺めるようにあたかもお答弁を呼びつけましたて、どうもきっと相当になったでいですのがまかり出ませう。</p>
      </div>
    </div>
    <div class="print-break"></div>
  </div>
</template>

<script>
export default {
  name: 'print'
}
</script>

<style scoped>
.contents {
  /* max-width: 800px; */
  margin: auto;
  padding: 0;
}

.grid {
  margin: 0;
  padding: 0;
	display: -webkit-flex;
  display: flex;
  list-style: none;
}

.grid-cell {
  margin: 5px;
  padding: 0px;
  border-radius: 5px;
  line-height: 1;
  color: #fff;
  background: #007bbb;
  flex: 1;
}

.twice {
  flex: 2;
}

.grid-cell p {
  display: block;
  margin: 0;
  padding: 20px;
  color: #fff;
  text-decoration: none;
}

@media print {
  body {
    -webkit-print-color-adjust: exact;
  }

  .single-page {
    background-color: transparent !important;
  }

  .print-break {
    page-break-after: always;
  }

  #close {
    display: none !important;
  }
}
</style>
